var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "beverages-container" }, [
    _c("div", {
      staticClass: "orders-backdrop",
      class: { visible: _vm.visible },
      on: { click: _vm.toggleOrders }
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "orders-summary", class: { visible: _vm.visible } },
      [
        _c("div", { staticClass: "close" }, [
          _c(
            "span",
            { staticClass: "clickable", on: { click: _vm.toggleOrders } },
            [_vm._v("×")]
          )
        ]),
        _vm._v(" "),
        _c(
          "ul",
          [
            _vm.total === 0
              ? _c("li", [_vm._v(_vm._s(_vm.i18n.orders.none))])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.orders, function(o) {
              return _c(
                "li",
                { key: o.id },
                [
                  _c(
                    "span",
                    { staticClass: "quantity", class: [o.beverage.basis] },
                    [_vm._v(_vm._s(o.quantity))]
                  ),
                  _vm._v("\n        " + _vm._s(o.beverage.name) + "\n        "),
                  o.beverage.brand
                    ? _c("small", [
                        _vm._v("(" + _vm._s(o.beverage.brand) + ")")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("min-max", {
                    attrs: {
                      display: o.beverage.preparation.temp,
                      icon: "icon-temp",
                      unit: _vm._f("map")(_vm.temperatureUnit, _vm.i18n.units)
                    }
                  }),
                  _vm._v(" "),
                  _c("min-max", {
                    attrs: {
                      display: o.beverage.preparation.time,
                      icon: "icon-time",
                      unit: _vm.i18n.units.minutes
                    }
                  })
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm.total !== 0
              ? _c(
                  "li",
                  { staticClass: "clickable", on: { click: _vm.clearOrders } },
                  [
                    _c("strong", [_vm._v("×")]),
                    _vm._v(" " + _vm._s(_vm.i18n.orders.clear) + "\n      ")
                  ]
                )
              : _vm._e()
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f0c76c22", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0c76c22","hasScoped":true,"optionsId":"1","buble":{"transforms":{}}}!./src/components/orders/orders.html
// module id = 133
// module chunks = 0